import calcSize from "src/functions/calcSize";

function gutter(
  type: "margin" | "padding",
  side: "all" | "top" | "left" | "bottom" | "right" | "horizontal" | "vertical",
  size:
    | "0"
    | "xt"
    | "tn"
    | "xs"
    | "sm"
    | "nm"
    | "xn"
    | "md"
    | "xm"
    | "lg"
    | "xl"
    | "hg"
    | "xh"
    | "xx"
) {
  return (function () {
    switch (type) {
      case `margin`:
        return (function () {
          switch (side) {
            case `all`:
              return {
                marginTop: calcSize(size),
                marginLeft: calcSize(size),
                marginBottom: calcSize(size),
                marginRight: calcSize(size),
              };
            case `top`:
              return { marginTop: calcSize(size) };
            case `left`:
              return { marginLeft: calcSize(size) };
            case `bottom`:
              return { marginBottom: calcSize(size) };
            case `right`:
              return { marginRight: calcSize(size) };
            case `horizontal`:
              return {
                marginLeft: calcSize(size),
                marginRight: calcSize(size),
              };
            case `vertical`:
              return {
                marginTop: calcSize(size),
                marginBottom: calcSize(size),
              };
          }
        })();
      case `padding`:
        return (function () {
          switch (side) {
            case `all`:
              return {
                paddingTop: calcSize(size),
                paddingLeft: calcSize(size),
                paddingBottom: calcSize(size),
                paddingRight: calcSize(size),
              };
            case `top`:
              return { paddingTop: calcSize(size) };
            case `left`:
              return { paddingLeft: calcSize(size) };
            case `bottom`:
              return { paddingBottom: calcSize(size) };
            case `right`:
              return { paddingRight: calcSize(size) };
            case `horizontal`:
              return {
                paddingLeft: calcSize(size),
                paddingRight: calcSize(size),
              };
            case `vertical`:
              return {
                paddingTop: calcSize(size),
                paddingBottom: calcSize(size),
              };
          }
        })();
    }
  })();
}

export default gutter;
